import { getFirst, isValid } from 'clients/Clients';
import { getSellerByCode } from 'clients/SellerClient';
import { BRAND_NAME } from 'constants/Enums';
import { DOMAIN_FLAGSHIP_STORE } from 'sysconfig';
import SellerUtils from 'utils/SellerUtils';
import create from 'zustand';
import { persist } from 'zustand/middleware';

const timeCache = 30 * 60 * 1000;
const defaultState = { mapSellers: {} };

const convertNameSeller = (sellerInfo, tags = []) => {
  const isVAT = tags?.indexOf('HOADONNHANH') >= 0 || false;
  let sellerName = '';
  let isDisplayStore = true;
  let fullNameSeller = '';
  const curTime = +new Date();
  const { isVip = false, name, status, slug = '', sellerType, sellerID, code, avatar, sellerClass } = sellerInfo || {};

  let linkSeller = sellerInfo?.landingPage?.startsWith('https://try.thuocsi.vn')
    ? sellerInfo?.landingPage
    : `/seller-products/${code}/${sellerInfo?.slugStore || sellerType == 'ENTERPRISE' ? sellerInfo?.slug : ''}`;

  let linkStore = `/seller/${slug}`;
  if (isVip) {
    linkStore = DOMAIN_FLAGSHIP_STORE.replace('{seller}', slug) || `/flagship-store/${slug}`;
  }
  if (sellerInfo?.isInternal) {
    fullNameSeller = 'MEDX';
    if (isVAT) {
      sellerName = 'MEDX';
    }
  } else if (sellerInfo?.sellerType === 'ENTERPRISE') {
    sellerName = sellerInfo?.name || '';
    fullNameSeller = sellerInfo?.fullName || '';
  } else {
    sellerName = `Đối tác của ${BRAND_NAME}`;
    isDisplayStore = false;
    fullNameSeller = `Đối tác của ${BRAND_NAME}`;
    linkSeller = `/doitac/${code}`;
  }
  return {
    isVip,
    name,
    linkSeller,
    linkStore,
    sellerName,
    isDisplayStore,
    fullNameSeller,
    status,
    slug,
    sellerType,
    sellerID,
    code,
    avatar,
    sellerClass,
    ttl: curTime + timeCache,
    createdTime: curTime,
  };
};

const convertSellerCache = (sellerInfo) => {
  const curTime = +new Date();

  return {
    ...sellerInfo,
    ttl: curTime + timeCache,
    createdTime: curTime,
  };
};

const useSellers = create(
  persist(
    (set, get) => ({
      ...defaultState,
      getSellerByCodeSync: ({ code, tags = [] }) => {
        const mapSellers = get()?.mapSellers || {};
        const sellerInfo = mapSellers[code];
        if (sellerInfo) {
          if (sellerInfo.ttl < +new Date()) {
            get()?.revalidateSellerByCode({ code });
          }
          return convertNameSeller(sellerInfo, tags);
        }
        get()?.revalidateSellerByCode({ code });
        return null;
      },
      getSellerByCodes: async ({ codes }) => codes?.map((code) => get()?.revalidateSellerByCode({ code })),

      getSellerByCode: async ({ code, tags }) => {
        const mapSellers = get()?.mapSellers || {};
        let sellerInfo = mapSellers[code];
        if (sellerInfo) {
          if (sellerInfo.ttl < +new Date()) get()?.revalidateSellerByCode({ code });
          return convertNameSeller(sellerInfo, tags);
        }

        sellerInfo = await get()?.revalidateSellerByCode({ code });
        return convertNameSeller(sellerInfo, tags);
      },
      revalidateSellerByCode: async ({ code = [] }) => {
        const mapSellers = get()?.mapSellers || {};
        // let sellerInfo = mapSellers[code];
        const sellerResult = await getSellerByCode({ sellerCode: code });
        // invalid seller result return null
        if (!isValid(sellerResult)) {
          return null;
        }
        // convert seller info
        const sellerInfo = SellerUtils.convertSeller(getFirst(sellerResult));
        if (sellerInfo) {
          mapSellers[code] = convertSellerCache(sellerInfo);
          set({ mapSellers });
        }
        return sellerInfo || null;
      },
      reset: () => {
        useSellers.persist.clearStorage();
        set(defaultState);
      },
    }),
    {
      name: 'sellerv2', // unique name
    },
  ),
);

export default useSellers;
